var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.isVisible,
        title: _vm.title,
        "destroy-on-close": true,
        width: _vm.width,
      },
      on: { close: _vm.hide },
    },
    [
      _vm.hasConversation
        ? _c("content-tabs", {
            staticStyle: { "margin-top": "-30px" },
            attrs: {
              conversation: _vm.conversation,
              "index-media-url": _vm.indexMediaUrl,
              "can-create-media": _vm.canCreateMedia,
              "store-media-url": _vm.storeMediaUrl,
              "can-send-message": _vm.canSendMessage,
              types: _vm.types,
            },
            on: {
              change: function ($event) {
                _vm.hasStructuralChanges = true
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "text-uppercase font-weight-bold",
          attrs: { slot: "title" },
          slot: "title",
        },
        [_vm._v(_vm._s(_vm.title))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }